import React from 'react';

interface ConsultingTabContentsProps {
	addClass?: string;
	title: string;
	desc: string;
	infoDesc: string[];
	focusList: string[];
	focusDetail: string[];
	attentionList: string[];
}
export default function ConsultingTabContents(props: ConsultingTabContentsProps) {
	const { addClass, title, desc, infoDesc, focusList, focusDetail, attentionList } = props;

	return (
		<div className={addClass}>
			<div className="box1">
				<div className="consult-info">
					<strong className="consult-title">{title}</strong>
					<p className="consult-desc">{desc}</p>
					<div className="text-box">
						{infoDesc.map((item, index) => (
							<p key={index}>
								{item.split('\n').map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</p>
						))}
					</div>
				</div>
			</div>

			<div className="box2"></div>

			<div className="box3">
				<strong className="consult-title-sub">주요분야</strong>
				<div className="consult-focus">
					<ul className="bullet-dot">
						{focusList.map((item, index) => (
							<li className="bullet" key={index}>
								{item}
							</li>
						))}
					</ul>
					<div className="consult-focus-desc ">
						<p className="desc-title">세부설명</p>
						<ul className="bullet-dot">
							{focusDetail.map((item, index) => (
								<li className="bullet" key={index}>
									{item}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>

			<div className="box4">
				<strong className="consult-title-sub icon">전문가문의 주의사항</strong>
				<ul className="bullet-dot">
					{attentionList.map((item, index) => (
						<li key={index} className="bullet">
							{item}
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}
